import { render, staticRenderFns } from "./CadastroPerfil.vue?vue&type=template&id=5d9d46c4&scoped=true"
import script from "./CadastroPerfil.vue?vue&type=script&lang=js"
export * from "./CadastroPerfil.vue?vue&type=script&lang=js"
import style0 from "./CadastroPerfil.vue?vue&type=style&index=0&id=5d9d46c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9d46c4",
  null
  
)

export default component.exports